/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagemDetalhesAliases {
  CONTEXTUAL_BAR_MENSAGEM = 'contextual-bar-mensagem',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_MENSAGEM = 'fetch-mensagem',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_DESCRICAO = 'field-descricao',
  FIELD_TITULO = 'field-titulo',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_TEXT_HTML = 'hpms-text-html',
  LISTA_ANEXOS = 'lista-anexos',
  MAPPER_LISTA_ANEXOS = 'mapper-lista-anexos',
  PANEL_0 = 'panel-0',
  PANEL_MENSAGEM_DETALHES = 'panel-mensagem-detalhes',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { MensagemDetalhesAliases };
